module.exports = __webpack_public_path__ + "img/6.d8173e19.webp";